import {Component, Input} from '@angular/core';

@Component({
    selector: 'banner',
    templateUrl: 'banner.html'
})
export class BannerComponent
{
    
    @Input() title: string;
    @Input() subtitle: string;
    
    constructor()
    {
        console.log('Hello BannerComponent Component');
        
    }
    
}



// WEBPACK FOOTER //
// ./src/components/banner/banner.ts